var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgHardBounce = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.75H1.99444C1.55885 12.75 1.34105 12.75 1.17467 12.6652C1.02833 12.5907 0.909341 12.4717 0.834773 12.3253C0.75 12.159 0.75 11.9412 0.75 11.5056V0.75M14.75 1.86111L10.5233 6.0878C10.3693 6.24181 10.2923 6.31881 10.2035 6.34766C10.1254 6.37304 10.0413 6.37304 9.96316 6.34766C9.87437 6.31881 9.79736 6.24181 9.64336 6.0878L8.18998 4.63442C8.03597 4.48042 7.95897 4.40341 7.87017 4.37456C7.79207 4.34918 7.70793 4.34918 7.62983 4.37456C7.54103 4.40341 7.46403 4.48042 7.31002 4.63442L3.86111 8.08333M14.75 1.86111H11.6389M14.75 1.86111V4.97222",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHardBounce, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hard-bounce.0a63268a.svg";
export { ForwardRef as ReactComponent };